
import {Component} from 'vue-property-decorator';
import OfferCreateForm from './create.vue';
import { pick } from 'lodash';


@Component
export default class Duplicate extends OfferCreateForm {
  get modalTitle(){
    return this.t('Duplicate Offer')
  }
  
  async load() {
    this.offer_id = this.$store.getters.selectedItem.id;
    const offer:any = await this.offerApi.get(this.offer_id).then((data: any) => {
      this.form = pick(data, [
        'name',
        'countryId',
        'tags',
        'url',
        'affiliateNetworkId',
        'clickIdParam',
        'currencyId',
        'payoutType',
        'payoutSum',
        'enableDailyCap',
        'dailyCapLimit',
        'dailyCapTimezone',
        'status',
        'workspaceId'
      ]);

      this.form.dailyCapFailoverOffer = {
        id:data.dailyCapFailoverOfferId,
        name:data.dailyCapFailoverOfferName
      }

      return data;
    });

    if(offer.enableDailyCap) {
      await this.loadDailyCapOffers();
    }
  }

  loadData() {
    this.$store.commit('loading', true);
    this.lastAffiliateNetworkId = this.form.affiliateNetworkId;

    this.load().then(() => {
      this.form.name = this.form.name + ' (' + this.t('____x.copy') + ')';
      this.offer_id = '';

      return this.getChangeAffiliatesPromise();
    })
      .then(() => {
        this.show = true;
        this.oldHash = this.getCurrentHash();
      })
      .finally(() => this.$store.commit('loading', false));
  }
}
